import { useState, useEffect } from "react";
import "../styles/SteamStatus.css";

function timeAgo(unixSeconds) {
    if (!unixSeconds) return null;
    const mins = Math.floor((Date.now() / 1000 - unixSeconds) / 60);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
}

function SteamStatus() {
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => { 
        const load = () =>
        fetch("/.netlify/functions/steam-status")
            .then((r) => r.json())
            .then((data) => setStatus(data.error ? null : data))
            .catch(() => setStatus(null))
            .finally(() => setLoading(false));

        load();
        const id = setInterval(load, 60000);
        return () => clearInterval(id);
    }, []);

    if (loading) {
        return <div className="steam-card steam-card--loading">Loading Steam status...</div>
    }

    if (!status) return null;

    let state = "offline";
    if (status.game) state = "ingame";
    else if (status.status ==="Away" || status.status === "Snooze") state = "away";
    else if (status.online) state = "online";

    const label = status.game ? "In-Game" : status.status;
    const lastOnline = !status.online ? timeAgo(status.lastLogoff) : null;

    return ( 
        <a
            className={`steam-card steam-card--${state}`}
            href={status.profileUrl}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className="steam-card__top">
                <img className="steam-card__avatar" src={status.avatar} alt="" />
                <div className="steam-card__info">
                    <h3 className="steam-card__name">{status.name}</h3>
                    <span className="steam-card_-status">
                        {label}
                        {lastOnline && <em> · last online {lastOnline} </em>}
                    </span>
                </div>
            </div>
            {status.game && (
                <div className="steam-card__game">
                    <img 
                        src={`https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/${status.gameId}/header.jpg`}
                        alt=""
                    />
                    <div>
                        <small>Now playing</small>
                        <strong>{status.game}</strong>
                    </div>
                </div>
            )}
        </a>
    );    
}

export default SteamStatus